import { Inject, Injectable } from '@angular/core';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { WINDOW } from '@lsq-frontend/angular-shared/settings';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { ClaimService } from '@lsq-frontend/common-ui';
import { combineLatest } from 'rxjs';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';

export interface BeamerWindow extends Window {
    Beamer: any;
    beamer_config: any;
}

@Injectable({ providedIn: 'root' })
export class BeamerService {
    constructor(
        public _userService: UserService,
        private _claimService: ClaimService,
        @Inject(WINDOW) private _window: BeamerWindow
    ) {
        SingletonServiceGuard.register('BeamerService');
    }

    public initialize(): void {
        combineLatest([this._claimService.claimStream, this._userService.user$]).subscribe(
            ([claims, user]) => {
                if (
                    user?.currentCompany &&
                    !(
                        claims[DashboardClaim.SystemManagement] ||
                        claims[DashboardClaim.SystemSupport]
                    )
                ) {
                    let filter = '';
                    if (claims[DashboardClaim.FactoringDashboard]) {
                        filter = 'factoring-user';
                    } else if (claims[DashboardClaim.FinancingVendorPortal]) {
                        filter = 'scf-supplier-user';
                    } else if (claims[DashboardClaim.FinancingBuyerPortal]) {
                        filter = 'scf-buyer-user';
                    }
                    if (filter && this._window.Beamer) {
                        this._window.Beamer.update({
                            user_firstname: user.firstName,
                            user_lastname: user.lastName,
                            user_email: user.emailAddress,
                            user_id: user.userKey,
                            filter: filter
                        });
                        this._window.Beamer.init();
                    }
                }
            }
        );
    }
}
